import { CloseCircleGreyIcon } from "assets";
import * as React from "react";
import { ToastData } from "state";

interface ToastProps extends ToastData {
  onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({ heading, text, show, type, onClose }) => {
  if (!show) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return 'text-green-600 bg-white';
      case 'error':
        return 'text-red-500 bg-[#FFE6E6]';
      case 'warning':
        return 'text-orange-600 bg-[#FFF3E6]';
      case 'info':
        return 'text-blue-500 bg-[#E6F0FF]';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <aside className={`fixed top-8 left-1/2 -translate-x-1/2 z-[99999] p-3 rounded flex items-start justify-between max-w-[350px] ${getTypeStyles()}`}>
      <div className="flex-1 mr-5">
        <p className="text-base font-medium">{heading}</p>
        <p className="m-0 text-sm text-gray-600">{text}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="p-0 w-fit h-fit bg-transparent hover:bg-transparent rounded-full transition-colors duration-200 flex-shrink-0"
          aria-label="Close toast"
        >
          <CloseCircleGreyIcon color="#667085"/>
        </button>
      )}
    </aside>
  );
};

export { Toast };